export const QUICK_FILL_APPLY_SUBMIT = 'QUICK_FILL_APPLY_SUBMIT'
export const QUICK_FILL_APPLY_SUCCESS = 'QUICK_FILL_APPLY_SUCCESS'
export const QUICK_FILL_APPLY_FAILURE = 'QUICK_FILL_APPLY_FAILURE'

export const QUICK_FILL_UNDO_SUBMIT = 'QUICK_FILL_UNDO_SUBMIT'
export const QUICK_FILL_UNDO_SUCCESS = 'QUICK_FILL_UNDO_SUCCESS'
export const QUICK_FILL_UNDO_FAILURE = 'QUICK_FILL_UNDO_FAILURE'
